import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'components/qstrap'

const AlertBox = props => (
  <div className="hide" ref={props.setRef}>
    <Alert color="danger">
      {props.text}
    </Alert>
  </div>
)

AlertBox.propTypes = {
  text: PropTypes.string.isRequired,
  setRef: PropTypes.func,
}

export default AlertBox
